<template>
    <div class="dock">
        <div class="dock-inner" v-for="item in items" :key="item.id">
            <router-link tag="a" :to="item.link" class="dock-button" :event="hideDock ? '' : 'click'"><i v-bind:class="item.class"></i></router-link>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Dock',
  data () {
    return {
      items: [
        {
          id: 0,
          link: '/menu/devices', //  search button
          class: 'fal fa-search fa-2x'
        },
        {
          id: 1,
          link: '/menu/events', // events list
          class: 'fal fa-map-marker-alt fa-2x'
        },
        {
          id: 2,
          link: '/menu/new', // add new device
          class: 'fal fa-plus-circle fa-2x'
        },
        {
          id: 3,
          link: '/menu/reports', // reports
          class: 'fal fa-list-alt fa-2x'
        },
        {
          id: 4,
          link: '/menu/settings', //  settings
          class: 'fal fa-cog fa-2x'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['hideDock'])
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/controls/Dock.vue